import { Injectable } from '@angular/core';
import { InvoiceRow } from '../model/invoice-row';
import { Money } from '../../core/model/money';

export class CalculatedInvoiceAmounts {
  netAmount: Money;
  vatAmount: Money;
  amount: Money;
  remainingAmount: Money;
  rounding: Money;
}

@Injectable()
export class InvoiceAmountService {
  calculateAmounts(rows: InvoiceRow[], currencyCode: string): CalculatedInvoiceAmounts {
    let netAmount = 0;
    let amount = 0;
    for (let row of rows) {
      netAmount += row.amount.amount;
      amount += row.amountIncludingVat.amount;
    }
    const vatAmount = amount - netAmount;
    const rounding = Money.RoundByCurrency(amount, currencyCode) - amount;

    return {
      netAmount: new Money(currencyCode, netAmount),
      vatAmount: new Money(currencyCode, vatAmount),
      amount: new Money(currencyCode, amount + rounding),
      remainingAmount: new Money(currencyCode, amount + rounding),
      rounding: new Money(currencyCode, rounding),
    };
  }

  calculateAmountInclVat(amount: Money, vatPercent: number): Money {
    return vatPercent ? new Money(amount.currencyCode, amount.amount + (amount.amount * vatPercent) / 100) : amount;
  }
}
